"use client";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AlertTriangle, AlertCircle, ArrowUpRight, Ban, Blocks, Brain, Braces, CalendarClock, Clock, Copy, Check, ChevronDown, ChevronUp, Gem, Globe, Eye, FileText, Info, Linkedin, ListFilter, Radio, Search, Share2, SlidersHorizontal, Volume2, Wrench, Zap } from "lucide-react";
import Link from "next/link.js";
import { useId, useMemo, useState } from "react";
import { CarrierMark } from "../carrier-mark.js";
import { getProviderIcon } from "../provider-icons.js";
import { Badge } from "../ui/badge.js";
import { Button } from "../ui/button.js";
import { Card } from "../ui/card.js";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../ui/dropdown-menu.js";
import { TooltipProvider } from "../ui/tooltip.js";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip.js";
import { isDeactivationScheduledSoon, isMappingDeactivated, MODEL_DEACTIVATION_NOTICE_DAYS, shouldShowDeactivationNotice } from "../../deactivation.js";
import { discountFraction } from "../../lib/discount.js";
import { cn } from "../../lib/utils.js";
import { formatNumber } from "../../number-format.js";
import { getDefaultProviderMapping } from "./default-provider-mapping.js";
import { formatContextSize, formatDeprecationDate, formatPerSecondPriceLabel, formatPerUnitPrice } from "./format.js";
import { getMappingCapabilities } from "./mapping-capabilities.js";
import { ModelCodeExampleDialog } from "./model-code-example-dialog.js";
import { ModelStatusBadge } from "./model-status-badge.js";
import { effectiveUnitPrice, formatLocalPeakWindows, formatPeakPricingSchedule } from "./pricing-schedule.js";
import { XIcon } from "./x-icon.js";
function PriceCell(_a) {
  var label = _a.label,
    price = _a.price,
    discount = _a.discount,
    unit = _a.unit,
    formatPrice = _a.formatPrice,
    _b = _a.multiplier,
    multiplier = _b === void 0 ? 1 : _b;
  var adjustedPrice = price !== null && price !== undefined && multiplier !== 1 ? String(Number(price) * multiplier) : price;
  var formatted = formatPrice(adjustedPrice, discount);
  return _jsxs("div", {
    className: "text-center",
    children: [_jsx("div", {
      className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-1",
      children: label
    }), _jsx("div", {
      className: "font-semibold text-foreground text-sm tabular-nums",
      children: formatted
    }), _jsx("div", {
      className: "text-[10px] text-muted-foreground",
      children: unit
    })]
  });
}
function StabilityDot(_a) {
  var stability = _a.stability;
  var level = stability !== null && stability !== void 0 ? stability : "stable";
  var colorClass = level === "stable" ? "bg-emerald-500" : level === "beta" ? "bg-amber-500" : "bg-red-500";
  return _jsxs(Tooltip, {
    children: [_jsx(TooltipTrigger, {
      asChild: true,
      children: _jsx("span", {
        className: cn("inline-block h-2 w-2 rounded-full shrink-0", colorClass)
      })
    }), _jsx(TooltipContent, {
      side: "top",
      className: "text-xs",
      children: level.charAt(0).toUpperCase() + level.slice(1)
    })]
  });
}
function LocalPeakPricingSchedule(_a) {
  var _b, _c;
  var peakPricing = _a.peakPricing;
  var now = new Date();
  var utcOffsetMinutes = -now.getTimezoneOffset();
  var timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  var offsetLabel = (_c = (_b = new Intl.DateTimeFormat("en-US", {
    timeZoneName: "shortOffset"
  }).formatToParts(now).find(function (part) {
    return part.type === "timeZoneName";
  })) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "";
  return _jsxs("div", {
    className: "max-w-64 space-y-1",
    children: [_jsxs("p", {
      className: "font-medium",
      children: ["In your time zone (", timeZone, ", ", offsetLabel, ")"]
    }), _jsxs("p", {
      children: ["Peak: ", formatLocalPeakWindows(peakPricing, utcOffsetMinutes), "."]
    }), _jsx("p", {
      children: "All other times are off-peak."
    })]
  });
}
function isImageGenModel(model) {
  return Array.isArray(model.output) && model.output.includes("image");
}
function hasEstimatedImageCost(mapping) {
  return Boolean(mapping.imageOutputPrice && mapping.imageOutputTokensByResolution);
}
var MAPPING_CAPABILITY_ICONS = {
  streaming: Zap,
  vision: Eye,
  audio: Volume2,
  document: FileText,
  tools: Wrench,
  reasoning: Brain,
  reasoningMaxTokens: SlidersHorizontal,
  jsonOutput: Braces,
  jsonOutputSchema: Blocks,
  webSearch: Search,
  realtime: Radio,
  rerank: ListFilter
};
export function ModelCard(_a) {
  var _this = this;
  var _b, _c;
  var model = _a.model,
    shouldShowStabilityWarning = _a.shouldShowStabilityWarning,
    getCapabilityIcons = _a.getCapabilityIcons,
    goToModel = _a.goToModel,
    formatPrice = _a.formatPrice,
    renderCta = _a.renderCta;
  var _d = useState(null),
    copiedModel = _d[0],
    setCopiedModel = _d[1];
  var _e = useState(false),
    showAllProviders = _e[0],
    setShowAllProviders = _e[1];
  var copyToClipboard = function (text) {
    return __awaiter(_this, void 0, void 0, function () {
      var _a;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);
            return [4, navigator.clipboard.writeText(text)];
          case 1:
            _b.sent();
            return [3, 3];
          case 2:
            _a = _b.sent();
            return [2];
          case 3:
            setCopiedModel(text);
            setTimeout(function () {
              return setCopiedModel(null);
            }, 2000);
            return [2];
        }
      });
    });
  };
  var now = new Date();
  var allHaveDeactivatedAt = model.providerDetails.length > 0 && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return provider.deactivatedAt;
  });
  var showModelDeactivationStatus = allHaveDeactivatedAt && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return shouldShowDeactivationNotice(provider, now);
  });
  var allHaveDeprecatedAt = !showModelDeactivationStatus && model.providerDetails.length > 0 && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return provider.deprecatedAt;
  });
  var deactivationAllPast = allHaveDeactivatedAt && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return new Date(provider.deactivatedAt) <= now;
  });
  var isAllScheduled = allHaveDeactivatedAt && !deactivationAllPast && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return shouldShowDeactivationNotice(provider, now);
  });
  var deprecationAllPast = allHaveDeprecatedAt && model.providerDetails.every(function (_a) {
    var provider = _a.provider;
    return new Date(provider.deprecatedAt) <= now;
  });
  var allBlocked = model.providerDetails.length > 0 && model.providerDetails.every(function (_a) {
    var _b;
    var provider = _a.provider;
    return (_b = provider.blockedReasons) === null || _b === void 0 ? void 0 : _b.length;
  });
  var blockedReasons = allBlocked ? Array.from(new Set(model.providerDetails.flatMap(function (_a) {
    var _b;
    var provider = _a.provider;
    return (_b = provider.blockedReasons) !== null && _b !== void 0 ? _b : [];
  }))) : [];
  var hasProviderStabilityWarning = function (provider) {
    return provider.stability !== null && provider.stability !== undefined && ["unstable", "experimental"].includes(provider.stability);
  };
  var groupedByProvider = useMemo(function () {
    var map = new Map();
    for (var _i = 0, _a = model.providerDetails; _i < _a.length; _i++) {
      var _b = _a[_i],
        provider = _b.provider,
        providerInfo = _b.providerInfo;
      var key = provider.providerId;
      if (!map.has(key)) {
        map.set(key, {
          providerInfo: providerInfo,
          providerId: key,
          mappings: []
        });
      }
      map.get(key).mappings.push(provider);
    }
    return Array.from(map.values()).sort(function (a, b) {
      var _a, _b;
      return Number(Boolean((_a = b.providerInfo) === null || _a === void 0 ? void 0 : _a.modelCardBadge)) - Number(Boolean((_b = a.providerInfo) === null || _b === void 0 ? void 0 : _b.modelCardBadge));
    });
  }, [model.providerDetails]);
  var bestDiscount = useMemo(function () {
    var max = 0;
    for (var _i = 0, _a = model.providerDetails; _i < _a.length; _i++) {
      var provider = _a[_i].provider;
      if (provider.discount) {
        var d = parseFloat(provider.discount);
        if (d > max) {
          max = d;
        }
      }
    }
    return max;
  }, [model.providerDetails]);
  var capabilities = useMemo(function () {
    if (model.providerDetails.length === 0) {
      return [];
    }
    var seen = new Set();
    var result = [];
    for (var _i = 0, _a = model.providerDetails; _i < _a.length; _i++) {
      var provider = _a[_i].provider;
      for (var _b = 0, _c = getCapabilityIcons(provider, model); _b < _c.length; _b++) {
        var cap = _c[_b];
        if (!seen.has(cap.label)) {
          seen.add(cap.label);
          result.push(cap);
        }
      }
    }
    return result;
  }, [model, getCapabilityIcons]);
  return _jsx(TooltipProvider, {
    children: _jsxs(Card, {
      className: "group relative overflow-hidden border border-border/50 bg-background hover:border-border transition-all duration-200 cursor-pointer py-0",
      onClick: goToModel,
      role: "link",
      tabIndex: 0,
      onKeyDown: function (e) {
        if (e.target === e.currentTarget && e.key === "Enter") {
          goToModel();
        }
      },
      children: [_jsx("div", {
        className: "h-px bg-gradient-to-r from-transparent via-primary/30 to-transparent"
      }), _jsxs("div", {
        className: "p-5",
        children: [_jsxs("div", {
          className: "mb-4",
          children: [_jsxs("div", {
            className: "flex items-start justify-between gap-3 mb-2",
            children: [_jsx("div", {
              className: "min-w-0 flex-1",
              children: _jsx("h2", {
                className: "text-lg font-bold text-foreground tracking-tight truncate",
                children: (_b = model.name) !== null && _b !== void 0 ? _b : model.id
              })
            }), _jsxs("div", {
              className: "flex items-center gap-1.5 shrink-0",
              children: [shouldShowStabilityWarning(model.stability) && _jsx(AlertTriangle, {
                className: "h-4 w-4 text-amber-400"
              }), _jsx("div", {
                onClick: function (e_0) {
                  return e_0.stopPropagation();
                },
                onMouseDown: function (e_1) {
                  return e_1.stopPropagation();
                },
                children: _jsx(ModelCodeExampleDialog, {
                  modelId: model.id
                })
              })]
            })]
          }), _jsxs("div", {
            className: "flex flex-wrap items-center gap-1.5",
            children: [_jsx(Badge, {
              variant: "secondary",
              className: "text-[10px] font-medium bg-muted/80 text-muted-foreground border-0 px-2 py-0.5",
              children: model.family
            }), model.premium && _jsxs(Badge, {
              className: "text-[10px] px-2 py-0.5 font-semibold bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20",
              children: [_jsx(Gem, {
                className: "h-2.5 w-2.5"
              }), "Premium"]
            }), bestDiscount > 0 && _jsxs(Badge, {
              className: "text-[10px] px-2 py-0.5 font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20",
              children: [Math.round(bestDiscount * 100), "% off"]
            }), model.source === "custom" && _jsx(Badge, {
              variant: "outline",
              className: "text-[10px] px-2 py-0.5 font-medium",
              children: "Custom"
            }), allBlocked && _jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsxs(Badge, {
                  className: "text-[10px] px-2 py-0.5 font-semibold bg-red-500/10 text-red-600 dark:text-red-400 border border-red-500/20 cursor-help",
                  children: [_jsx(Ban, {
                    className: "h-2.5 w-2.5"
                  }), "Not eligible"]
                })
              }), _jsxs(TooltipContent, {
                className: "max-w-xs",
                children: [_jsx("p", {
                  className: "text-xs font-medium mb-1",
                  children: "Not available under your organization's compliance policy:"
                }), _jsx("ul", {
                  className: cn("text-xs", blockedReasons.length > 1 && "list-disc pl-4 space-y-0.5"),
                  children: blockedReasons.map(function (reason) {
                    return _jsx("li", {
                      children: reason
                    }, reason);
                  })
                })]
              })]
            }), deactivationAllPast && _jsx(ModelStatusBadge, {
              status: "deactivated",
              isPast: true
            }), isAllScheduled && _jsx(ModelStatusBadge, {
              status: "scheduled"
            }), allHaveDeprecatedAt && _jsx(ModelStatusBadge, {
              status: "deprecated",
              isPast: deprecationAllPast
            })]
          })]
        }), _jsxs("div", {
          className: "flex items-center gap-1.5 px-2.5 py-2 rounded-md bg-muted/50 border border-border/50 mb-4",
          children: [_jsx("code", {
            className: "text-xs font-mono text-muted-foreground flex-1 truncate",
            children: model.id
          }), _jsx(Button, {
            variant: "ghost",
            size: "sm",
            className: "h-6 w-6 p-0 shrink-0 text-muted-foreground/60 hover:text-foreground hover:bg-transparent",
            onClick: function (e_2) {
              e_2.stopPropagation();
              void copyToClipboard(model.id);
            },
            title: "Copy model ID",
            children: copiedModel === model.id ? _jsx(Check, {
              className: "h-3.5 w-3.5 text-emerald-400"
            }) : _jsx(Copy, {
              className: "h-3.5 w-3.5"
            })
          })]
        }), capabilities.length > 0 && _jsx("div", {
          className: "flex flex-wrap gap-1.5 mb-4",
          children: capabilities.map(function (_a_0) {
            var Icon = _a_0.icon,
              label = _a_0.label,
              color = _a_0.color;
            return _jsxs(Tooltip, {
              children: [_jsx(TooltipTrigger, {
                asChild: true,
                children: _jsxs("div", {
                  className: cn("inline-flex items-center gap-1 px-2 py-1 rounded-md text-[11px] font-medium cursor-help transition-colors", "bg-muted/50 text-muted-foreground hover:bg-muted border border-transparent hover:border-border/50"),
                  children: [_jsx(Icon, {
                    size: 12,
                    className: color
                  }), label]
                })
              }), _jsxs(TooltipContent, {
                side: "top",
                className: "text-xs",
                children: ["Supports ", label.toLowerCase()]
              })]
            }, label);
          })
        }), _jsxs("div", {
          className: "space-y-3",
          children: [(showAllProviders ? groupedByProvider : groupedByProvider.slice(0, 1)).map(function (_a_1) {
            var providerInfo = _a_1.providerInfo,
              providerId = _a_1.providerId,
              mappings = _a_1.mappings;
            var ProviderIcon = getProviderIcon(providerId);
            var hasRegions = mappings.length > 1 || mappings.length === 1 && !!mappings[0].region;
            return _jsx(ProviderSection, {
              modelId: model.id,
              providerInfo: providerInfo,
              providerId: providerId,
              ProviderIcon: ProviderIcon,
              mappings: mappings,
              hasRegions: hasRegions,
              hasProviderStabilityWarning: hasProviderStabilityWarning,
              formatPrice: formatPrice,
              copyToClipboard: copyToClipboard,
              copiedModel: copiedModel,
              isImageGen: isImageGenModel(model)
            }, providerId);
          }), groupedByProvider.length > 1 && _jsx("button", {
            type: "button",
            className: "w-full flex items-center justify-center gap-1.5 py-2 text-xs text-muted-foreground hover:text-foreground transition-colors",
            onClick: function (e_3) {
              e_3.stopPropagation();
              setShowAllProviders(function (v) {
                return !v;
              });
            },
            children: showAllProviders ? _jsxs(_Fragment, {
              children: [_jsx(ChevronUp, {
                className: "h-3.5 w-3.5"
              }), "Fewer providers"]
            }) : _jsxs(_Fragment, {
              children: [_jsx(ChevronDown, {
                className: "h-3.5 w-3.5"
              }), groupedByProvider.length - 1, " more provider", groupedByProvider.length - 1 > 1 ? "s" : ""]
            })
          })]
        }), _jsx("div", {
          className: "mt-4 pt-4 border-t border-border/30",
          children: renderCta === null || renderCta === void 0 ? void 0 : renderCta({
            modelId: "".concat((_c = groupedByProvider[0]) === null || _c === void 0 ? void 0 : _c.providerId, "/").concat(model.id),
            output: model.output,
            onClick: function (e_4) {
              return e_4.stopPropagation();
            }
          })
        })]
      })]
    })
  });
}
function ShareDropdown(_a) {
  var _this = this;
  var modelId = _a.modelId,
    providerId = _a.providerId;
  var _b = useState(false),
    urlCopied = _b[0],
    setUrlCopied = _b[1];
  var shareUrl = "https://llmgateway.io/models/".concat(encodeURIComponent(modelId), "/").concat(encodeURIComponent(providerId));
  var shareTitle = "".concat(providerId, " - ").concat(modelId, " on LLM Gateway");
  return _jsxs(DropdownMenu, {
    children: [_jsx(DropdownMenuTrigger, {
      asChild: true,
      children: _jsx(Button, {
        variant: "ghost",
        size: "sm",
        className: "h-6 w-6 p-0 text-muted-foreground/60 hover:text-foreground hover:bg-transparent",
        onClick: function (e) {
          return e.stopPropagation();
        },
        title: "Share",
        children: _jsx(Share2, {
          className: "h-3 w-3"
        })
      })
    }), _jsxs(DropdownMenuContent, {
      align: "end",
      children: [_jsxs(DropdownMenuItem, {
        onClick: function (e_0) {
          return __awaiter(_this, void 0, void 0, function () {
            var _a_0;
            return __generator(this, function (_b) {
              switch (_b.label) {
                case 0:
                  e_0.stopPropagation();
                  _b.label = 1;
                case 1:
                  _b.trys.push([1, 3,, 4]);
                  return [4, navigator.clipboard.writeText(shareUrl)];
                case 2:
                  _b.sent();
                  return [3, 4];
                case 3:
                  _a_0 = _b.sent();
                  return [2];
                case 4:
                  setUrlCopied(true);
                  setTimeout(function () {
                    return setUrlCopied(false);
                  }, 2000);
                  return [2];
              }
            });
          });
        },
        className: "cursor-pointer",
        children: [urlCopied ? _jsx(Check, {
          className: "h-4 w-4 mr-2 text-green-500"
        }) : _jsx(Copy, {
          className: "h-4 w-4 mr-2"
        }), urlCopied ? "Copied!" : "Copy URL"]
      }), _jsx(DropdownMenuItem, {
        asChild: true,
        className: "cursor-pointer",
        children: _jsxs("a", {
          href: "https://x.com/intent/tweet?url=".concat(encodeURIComponent(shareUrl), "&text=").concat(encodeURIComponent(shareTitle)),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: function (e_1) {
            return e_1.stopPropagation();
          },
          children: [_jsx(XIcon, {
            className: "h-4 w-4 mr-2"
          }), "Share on X"]
        })
      }), _jsx(DropdownMenuItem, {
        asChild: true,
        className: "cursor-pointer",
        children: _jsxs("a", {
          href: "https://www.linkedin.com/sharing/share-offsite/?url=".concat(encodeURIComponent(shareUrl)),
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: function (e_2) {
            return e_2.stopPropagation();
          },
          children: [_jsx(Linkedin, {
            className: "h-4 w-4 mr-2"
          }), "Share on LinkedIn"]
        })
      })]
    })]
  });
}
export function ProviderSection(_a) {
  var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
  var modelId = _a.modelId,
    providerInfo = _a.providerInfo,
    providerId = _a.providerId,
    ProviderIcon = _a.ProviderIcon,
    mappings = _a.mappings,
    hasRegions = _a.hasRegions,
    hasProviderStabilityWarning = _a.hasProviderStabilityWarning,
    formatPrice = _a.formatPrice,
    copyToClipboard = _a.copyToClipboard,
    copiedModel = _a.copiedModel,
    _6 = _a.isImageGen,
    isImageGen = _6 === void 0 ? false : _6,
    _7 = _a.detailed,
    detailed = _7 === void 0 ? false : _7,
    providerHref = _a.providerHref,
    headerExtra = _a.headerExtra;
  var _8 = useState(),
    selectedRegion = _8[0],
    setSelectedRegion = _8[1];
  var mappingDetailsId = useId();
  var _9 = useState(false),
    showTokenPricing = _9[0],
    setShowTokenPricing = _9[1];
  var _10 = useState(false),
    showMappingDetails = _10[0],
    setShowMappingDetails = _10[1];
  var _11 = useState("peak"),
    timeBasedPricingMode = _11[0],
    setTimeBasedPricingMode = _11[1];
  var _12 = useState("standard"),
    selectedServiceTierId = _12[0],
    setSelectedServiceTierId = _12[1];
  var activeMapping = (_b = mappings.find(function (mapping) {
    var _a;
    return selectedRegion !== undefined && ((_a = mapping.region) !== null && _a !== void 0 ? _a : null) === selectedRegion;
  })) !== null && _b !== void 0 ? _b : getDefaultProviderMapping(mappings);
  var isDeactivated = isMappingDeactivated(activeMapping);
  var isScheduled = !isDeactivated && isDeactivationScheduledSoon(activeMapping, undefined, MODEL_DEACTIVATION_NOTICE_DAYS);
  var showDeactivationNotice = isDeactivated || isScheduled;
  var mappingCapabilities = getMappingCapabilities(activeMapping);
  var hasMappingDetails = mappingCapabilities.length > 0 || ((_d = (_c = activeMapping.reasoningEfforts) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0) > 0 || ((_f = (_e = activeMapping.supportedParameters) === null || _e === void 0 ? void 0 : _e.length) !== null && _f !== void 0 ? _f : 0) > 0;
  var supportedServiceTierIds = new Set((_g = activeMapping.serviceTiers) !== null && _g !== void 0 ? _g : []);
  var serviceTiers = ((_h = providerInfo.serviceTiers) !== null && _h !== void 0 ? _h : []).filter(function (tier) {
    return supportedServiceTierIds.has(tier.id);
  });
  var activeServiceTierId = selectedServiceTierId === "standard" || serviceTiers.some(function (tier) {
    return tier.id === selectedServiceTierId;
  }) ? selectedServiceTierId : "standard";
  var serviceTierMultiplier = (_k = (_j = serviceTiers.find(function (tier) {
    return tier.id === activeServiceTierId;
  })) === null || _j === void 0 ? void 0 : _j.multiplier) !== null && _k !== void 0 ? _k : 1;
  var providerModelId = activeMapping.region ? "".concat(providerId, "/").concat(modelId, ":").concat(activeMapping.region) : "".concat(providerId, "/").concat(modelId);
  var hasImageCostEstimate = hasEstimatedImageCost(activeMapping);
  var shouldShowTokenPricing = !isImageGen || showTokenPricing || !hasImageCostEstimate;
  var timeBasedPrices = (_l = activeMapping.peakPricing) === null || _l === void 0 ? void 0 : _l[timeBasedPricingMode];
  var displayedInputPrice = (_m = timeBasedPrices === null || timeBasedPrices === void 0 ? void 0 : timeBasedPrices.inputPrice) !== null && _m !== void 0 ? _m : activeMapping.inputPrice;
  var displayedCachedInputPrice = (_o = timeBasedPrices === null || timeBasedPrices === void 0 ? void 0 : timeBasedPrices.cachedInputPrice) !== null && _o !== void 0 ? _o : activeMapping.cachedInputPrice;
  var displayedOutputPrice = (_p = timeBasedPrices === null || timeBasedPrices === void 0 ? void 0 : timeBasedPrices.outputPrice) !== null && _p !== void 0 ? _p : activeMapping.outputPrice;
  var pricingSchedule = activeMapping.peakPricing ? formatPeakPricingSchedule(activeMapping.peakPricing) : null;
  var providerBrandUrl = (_q = providerInfo.airsideIconUrl) !== null && _q !== void 0 ? _q : providerInfo.airsideLogoUrl;
  var providerMark = _jsx("div", {
    className: "w-5 h-5 rounded flex items-center justify-center shrink-0",
    children: providerBrandUrl ? _jsx(CarrierMark, {
      src: providerBrandUrl,
      className: "h-4 w-4 object-contain"
    }) : ProviderIcon ? _jsx(ProviderIcon, {
      className: "h-4 w-4"
    }) : _jsx("span", {
      className: "text-[10px] font-bold text-muted-foreground",
      children: ((_r = providerInfo.name) !== null && _r !== void 0 ? _r : providerId).charAt(0).toUpperCase()
    })
  });
  return _jsxs("div", {
    className: "flex flex-1 flex-col rounded-lg border border-border/50 bg-muted/20 overflow-hidden",
    children: [_jsxs("div", {
      className: "flex items-center justify-between gap-2 px-3 py-2.5 border-b border-border/30",
      children: [_jsxs("div", {
        className: "flex items-center gap-2 min-w-0",
        children: [providerHref ? _jsxs(Link, {
          href: providerHref,
          onClick: function (e) {
            return e.stopPropagation();
          },
          className: "group/provider flex items-center gap-2 min-w-0",
          title: "About ".concat((_s = providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.name) !== null && _s !== void 0 ? _s : providerId),
          children: [providerMark, _jsx("span", {
            className: "text-sm font-semibold text-foreground truncate underline-offset-4 decoration-border group-hover/provider:underline",
            children: (_t = providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.name) !== null && _t !== void 0 ? _t : providerId
          }), _jsx(ArrowUpRight, {
            className: "h-3 w-3 shrink-0 text-muted-foreground/50 transition-[transform,color] duration-150 ease-out group-hover/provider:text-foreground group-hover/provider:translate-x-px group-hover/provider:-translate-y-px"
          })]
        }) : _jsxs(_Fragment, {
          children: [providerMark, _jsx("span", {
            className: "text-sm font-semibold text-foreground truncate",
            children: (_u = providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.name) !== null && _u !== void 0 ? _u : providerId
          })]
        }), _jsx(StabilityDot, {
          stability: activeMapping.stability
        }), hasProviderStabilityWarning(activeMapping) && _jsx(AlertTriangle, {
          className: "h-3.5 w-3.5 text-amber-400 shrink-0"
        }), (providerInfo === null || providerInfo === void 0 ? void 0 : providerInfo.modelCardBadge) && _jsxs(Badge, {
          className: "text-[10px] px-1.5 py-0 h-4 gap-1 font-semibold whitespace-nowrap shrink-0 bg-amber-500/10 text-amber-600 dark:text-amber-400 border border-amber-500/20",
          children: [_jsx(Zap, {
            className: "h-2.5 w-2.5"
          }), providerInfo.modelCardBadge]
        }), headerExtra]
      }), _jsxs("div", {
        className: "flex items-center gap-1 shrink-0",
        children: [serviceTiers.length > 0 && _jsxs("div", {
          className: "flex h-6 items-center rounded-md border border-border/50 bg-background/80 p-0.5",
          "aria-label": "Service tier",
          children: [_jsxs("button", {
            type: "button",
            onClick: function () {
              return setSelectedServiceTierId("standard");
            },
            className: cn("inline-flex h-5 items-center gap-1 rounded px-1.5 text-[10px] font-medium leading-none transition-colors", activeServiceTierId === "standard" ? "bg-muted text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"),
            "aria-pressed": activeServiceTierId === "standard",
            title: "Standard pricing (1x)",
            children: [_jsx("span", {
              children: "Std"
            }), _jsx("span", {
              className: cn("text-[9px] font-medium", activeServiceTierId === "standard" ? "text-foreground/65" : "text-muted-foreground"),
              children: "1x"
            })]
          }), serviceTiers.map(function (tier) {
            var isSelected = activeServiceTierId === tier.id;
            return _jsxs("button", {
              type: "button",
              onClick: function () {
                return setSelectedServiceTierId(tier.id);
              },
              className: cn("inline-flex h-5 items-center gap-1 rounded px-1.5 text-[10px] font-medium leading-none transition-colors", isSelected ? "bg-muted text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"),
              "aria-pressed": isSelected,
              title: "".concat(tier.name, " (").concat(tier.multiplier, "x pricing)"),
              children: [_jsx("span", {
                children: tier.name
              }), _jsxs("span", {
                className: cn("text-[9px] font-medium", isSelected ? "text-foreground/65" : "text-muted-foreground"),
                children: [tier.multiplier, "x"]
              })]
            }, tier.id);
          })]
        }), _jsx(ShareDropdown, {
          modelId: modelId,
          providerId: providerId
        }), _jsx(Button, {
          variant: "ghost",
          size: "sm",
          className: "h-6 w-6 p-0 text-muted-foreground/60 hover:text-foreground hover:bg-transparent",
          onClick: function (e_0) {
            e_0.stopPropagation();
            copyToClipboard(providerModelId);
          },
          title: "Copy provider/model ID",
          children: copiedModel === providerModelId ? _jsx(Check, {
            className: "h-3 w-3 text-emerald-400"
          }) : _jsx(Copy, {
            className: "h-3 w-3"
          })
        }), _jsx("div", {
          onClick: function (e_1) {
            return e_1.stopPropagation();
          },
          onMouseDown: function (e_2) {
            return e_2.stopPropagation();
          },
          children: _jsx(ModelCodeExampleDialog, {
            modelId: providerModelId
          })
        })]
      })]
    }), hasRegions && mappings.length > 1 && _jsxs("div", {
      className: "flex items-center gap-0.5 px-3 py-1.5 border-b border-border/30 bg-muted/30 overflow-x-auto",
      children: [_jsx(Globe, {
        className: "h-3 w-3 text-muted-foreground/50 shrink-0 mr-1"
      }), mappings.map(function (mapping, idx) {
        var _a_1, _b;
        return _jsx("button", {
          type: "button",
          "aria-pressed": activeMapping === mapping,
          onClick: function (e_3) {
            var _a_0;
            e_3.stopPropagation();
            setSelectedRegion((_a_0 = mapping.region) !== null && _a_0 !== void 0 ? _a_0 : null);
          },
          className: cn("px-2 py-1 rounded text-[10px] font-medium transition-colors whitespace-nowrap", activeMapping === mapping ? "bg-background text-foreground shadow-sm border border-border/50" : "text-muted-foreground hover:text-foreground"),
          children: (_a_1 = mapping.region) !== null && _a_1 !== void 0 ? _a_1 : "Default"
        }, "".concat(mapping.providerId, "-").concat((_b = mapping.region) !== null && _b !== void 0 ? _b : "default", "-").concat(idx));
      })]
    }), _jsxs("div", {
      className: "px-3 py-3 space-y-3",
      children: [_jsxs("div", {
        className: "flex items-center justify-between text-xs",
        children: [_jsxs("span", {
          className: "flex items-center gap-3 text-muted-foreground",
          children: [_jsxs("span", {
            children: ["Context:", " ", _jsx("span", {
              className: "text-foreground font-medium",
              children: activeMapping.contextSize ? formatContextSize(activeMapping.contextSize) : "—"
            })]
          }), activeMapping.quantization && _jsxs("span", {
            children: ["Quant:", " ", _jsx("span", {
              className: "text-foreground font-medium uppercase",
              children: activeMapping.quantization
            })]
          })]
        }), activeMapping.discount && parseFloat(activeMapping.discount) > 0 && _jsxs(Badge, {
          className: "text-[10px] px-1.5 py-0 h-4 font-semibold bg-emerald-500/10 text-emerald-600 dark:text-emerald-400 border border-emerald-500/20",
          children: [Math.round(parseFloat(activeMapping.discount) * 100), "% off"]
        })]
      }), (activeMapping.deprecatedAt || showDeactivationNotice) && _jsxs("div", {
        className: "flex flex-wrap gap-1.5",
        children: [activeMapping.deprecatedAt && _jsxs(Badge, {
          variant: "outline",
          className: "text-[10px] px-2 py-0.5 gap-1 bg-amber-500/5 text-amber-600 dark:text-amber-400 border-amber-500/20",
          children: [_jsx(AlertTriangle, {
            className: "h-2.5 w-2.5"
          }), formatDeprecationDate(activeMapping.deprecatedAt, "deprecated")]
        }), isDeactivated && _jsxs(Badge, {
          variant: "outline",
          className: "text-[10px] px-2 py-0.5 gap-1 bg-red-500/5 text-red-600 dark:text-red-400 border-red-500/20",
          children: [_jsx(AlertCircle, {
            className: "h-2.5 w-2.5"
          }), formatDeprecationDate(activeMapping.deactivatedAt, "deactivated")]
        }), isScheduled && _jsxs(Badge, {
          variant: "outline",
          className: "text-[10px] px-2 py-0.5 gap-1 bg-amber-500/5 text-amber-600 dark:text-amber-400 border-amber-500/20",
          children: [_jsx(Clock, {
            className: "h-2.5 w-2.5"
          }), formatDeprecationDate(activeMapping.deactivatedAt, "deactivated")]
        })]
      }), isImageGen && function () {
        var _a, _b;
        var discountNum = discountFraction(activeMapping.discount);
        var requestPriceNum = activeMapping.requestPrice !== null && activeMapping.requestPrice !== undefined ? parseFloat(activeMapping.requestPrice) : 0;
        var perImage = null;
        var label = "Per image";
        var outputCost = 0;
        var resolutionKey = null;
        if (activeMapping.imageOutputPrice && activeMapping.imageOutputTokensByResolution) {
          var outPrice = parseFloat(activeMapping.imageOutputPrice);
          var entries = Object.entries(activeMapping.imageOutputTokensByResolution);
          var preferred = (_a = entries.find(function (_a) {
            var k = _a[0];
            return k !== "default";
          })) !== null && _a !== void 0 ? _a : entries[0];
          if (preferred) {
            outputCost = preferred[1] * outPrice;
            resolutionKey = preferred[0];
          }
          if (requestPriceNum > 0 || outputCost > 0) {
            perImage = (requestPriceNum + outputCost) * serviceTierMultiplier;
            if (resolutionKey) {
              label = "Per image (".concat(resolutionKey, ")");
            }
          }
        }
        if (perImage === null && activeMapping.perImagePrice) {
          var tierEntries = Object.entries(activeMapping.perImagePrice).filter(function (_a) {
            var k = _a[0];
            return k !== "default";
          });
          var entries = tierEntries.length > 0 ? tierEntries : Object.entries(activeMapping.perImagePrice);
          var values = entries.map(function (_a) {
            var v = _a[1];
            return parseFloat(v);
          }).filter(Number.isFinite);
          if (values.length > 0) {
            var min = Math.min.apply(Math, values);
            var max_1 = Math.max.apply(Math, values);
            perImage = max_1 * serviceTierMultiplier;
            if (min !== max_1) {
              var maxKey = (_b = entries.find(function (_a) {
                var v = _a[1];
                return parseFloat(v) === max_1;
              })) === null || _b === void 0 ? void 0 : _b[0];
              label = maxKey ? "Per image (".concat(maxKey, ", cheaper at lower resolutions)") : "Per image";
            }
          }
        }
        if (perImage === null) {
          return null;
        }
        var discounted = perImage * (1 - discountNum);
        return _jsx("div", {
          className: "rounded-md bg-muted/40 border border-border/30 p-3",
          children: _jsxs("div", {
            className: "flex items-center justify-between gap-2",
            children: [_jsx("div", {
              className: "text-[10px] uppercase tracking-wider text-muted-foreground",
              children: label
            }), _jsx("div", {
              className: "font-semibold tabular-nums text-sm",
              children: discountNum > 0 ? _jsxs(_Fragment, {
                children: [_jsxs("span", {
                  className: "line-through text-muted-foreground mr-1 text-xs",
                  children: ["$", perImage.toFixed(5)]
                }), _jsxs("span", {
                  className: "text-green-600",
                  children: ["$", discounted.toFixed(5)]
                })]
              }) : "$".concat(perImage.toFixed(5))
            })]
          })
        });
      }(), shouldShowTokenPricing && activeMapping.inputCharacterPrice && parseFloat(activeMapping.inputCharacterPrice) > 0 && function () {
        var discountNum_0 = discountFraction(activeMapping.discount);
        var perThousandChars = parseFloat(activeMapping.inputCharacterPrice) * 1000 * serviceTierMultiplier;
        var formatChars = function (value) {
          return "$".concat(parseFloat(value.toFixed(5)));
        };
        return _jsxs("div", {
          className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
          children: [_jsx("div", {
            className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
            children: "Per Character Pricing"
          }), _jsxs("div", {
            className: "flex justify-between text-sm",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: "Input text"
            }), _jsxs("span", {
              className: "font-semibold tabular-nums",
              children: [discountNum_0 > 0 ? _jsxs(_Fragment, {
                children: [_jsx("span", {
                  className: "line-through text-muted-foreground mr-1 text-xs",
                  children: formatChars(perThousandChars)
                }), _jsx("span", {
                  className: "text-green-600",
                  children: formatChars(perThousandChars * (1 - discountNum_0))
                })]
              }) : formatChars(perThousandChars), _jsx("span", {
                className: "text-muted-foreground text-xs ml-0.5",
                children: "/1K chars"
              })]
            })]
          })]
        });
      }(), !shouldShowTokenPricing || activeMapping.inputCharacterPrice && parseFloat(activeMapping.inputCharacterPrice) > 0 ? null : activeMapping.perSecondPrice && Object.keys(activeMapping.perSecondPrice).length > 0 ? _jsxs("div", {
        className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
        children: [_jsx("div", {
          className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
          children: "Per Second Pricing"
        }), _jsx("div", {
          className: "space-y-1",
          children: function () {
            var prices = activeMapping.perSecondPrice;
            var discounted_0 = discountFraction(activeMapping.discount) > 0;
            var label_0 = formatPerSecondPriceLabel(prices, activeMapping.discount, serviceTierMultiplier);
            if (label_0) {
              return _jsxs("div", {
                className: "flex justify-between text-sm",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: label_0.tiers.length > 1 ? "Video / Audio" : "Default"
                }), _jsxs("span", {
                  className: "font-semibold tabular-nums",
                  children: [discounted_0 ? _jsxs(_Fragment, {
                    children: [_jsx("span", {
                      className: "line-through text-muted-foreground mr-1 text-xs",
                      children: label_0.original
                    }), _jsx("span", {
                      className: "text-green-600",
                      children: label_0.value
                    })]
                  }) : label_0.value, _jsx("span", {
                    className: "text-muted-foreground text-xs ml-0.5",
                    children: "/sec"
                  })]
                })]
              });
            }
            return Object.entries(prices).map(function (_a_2) {
              var key = _a_2[0],
                value = _a_2[1];
              var price = effectiveUnitPrice(value, activeMapping.discount);
              return price === null ? null : _jsxs("div", {
                className: "flex justify-between text-xs",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: key
                }), _jsxs("span", {
                  className: "font-mono tabular-nums",
                  children: [formatPerUnitPrice(price * serviceTierMultiplier), "/sec"]
                })]
              }, key);
            });
          }()
        })]
      }) : activeMapping.inputAudioHourPrice && parseFloat(activeMapping.inputAudioHourPrice) > 0 && !(parseFloat((_v = activeMapping.inputPrice) !== null && _v !== void 0 ? _v : "0") > 0) && !(parseFloat((_w = activeMapping.outputPrice) !== null && _w !== void 0 ? _w : "0") > 0) ? function () {
        var discountNum_1 = discountFraction(activeMapping.discount);
        var perHour = parseFloat(activeMapping.inputAudioHourPrice) * serviceTierMultiplier;
        var formatHour = function (value) {
          return "$".concat(parseFloat(value.toFixed(5)));
        };
        return _jsxs("div", {
          className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
          children: [_jsx("div", {
            className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
            children: "Audio Transcription Pricing"
          }), _jsxs("div", {
            className: "flex justify-between text-sm",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: "Input audio"
            }), _jsxs("span", {
              className: "font-semibold tabular-nums",
              children: [discountNum_1 > 0 ? _jsxs(_Fragment, {
                children: [_jsx("span", {
                  className: "line-through text-muted-foreground mr-1 text-xs",
                  children: formatHour(perHour)
                }), _jsx("span", {
                  className: "text-green-600",
                  children: formatHour(perHour * (1 - discountNum_1))
                })]
              }) : formatHour(perHour), _jsx("span", {
                className: "text-muted-foreground text-xs ml-0.5",
                children: "/hour"
              })]
            })]
          })]
        });
      }() : _jsxs("div", {
        className: "space-y-2",
        children: [activeMapping.peakPricing && _jsxs("div", {
          className: "flex items-center justify-between gap-3",
          children: [_jsx("span", {
            className: "text-[10px] font-medium uppercase tracking-wider text-muted-foreground",
            children: "Time-based pricing"
          }), _jsx("div", {
            className: "flex h-7 items-center rounded-md border border-border/50 bg-background p-0.5",
            role: "group",
            "aria-label": "Pricing rate",
            children: [["peak", "Peak"], ["offPeak", "Off-peak"]].map(function (_a_3) {
              var mode = _a_3[0],
                label_1 = _a_3[1];
              var isSelected_0 = timeBasedPricingMode === mode;
              return _jsx("button", {
                type: "button",
                onClick: function () {
                  return setTimeBasedPricingMode(mode);
                },
                className: cn("h-6 rounded px-2 text-[10px] font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1", isSelected_0 ? "bg-muted text-foreground shadow-sm" : "text-muted-foreground hover:text-foreground"),
                "aria-pressed": isSelected_0,
                children: label_1
              }, mode);
            })
          })]
        }), _jsxs("div", {
          className: "grid grid-cols-3 gap-px rounded-md bg-border/30 border border-border/30 overflow-hidden",
          children: [_jsx("div", {
            className: "bg-background p-2",
            children: _jsx(PriceCell, {
              label: "Input",
              price: displayedInputPrice,
              discount: activeMapping.discount,
              unit: "/M tokens",
              formatPrice: formatPrice,
              multiplier: serviceTierMultiplier
            })
          }), _jsx("div", {
            className: "bg-background p-2",
            children: _jsx(PriceCell, {
              label: detailed ? "Cache Read" : "Cached",
              price: displayedCachedInputPrice,
              discount: activeMapping.discount,
              unit: "/M tokens",
              formatPrice: formatPrice,
              multiplier: serviceTierMultiplier
            })
          }), _jsx("div", {
            className: "bg-background p-2",
            children: _jsx(PriceCell, {
              label: "Output",
              price: displayedOutputPrice,
              discount: activeMapping.discount,
              unit: "/M tokens",
              formatPrice: formatPrice,
              multiplier: serviceTierMultiplier
            })
          })]
        }), activeMapping.peakPricing && pricingSchedule && _jsxs("div", {
          className: "flex items-start gap-2 px-0.5 pt-0.5 text-[11px] leading-relaxed text-muted-foreground",
          children: [_jsx(CalendarClock, {
            className: "mt-0.5 h-3.5 w-3.5 shrink-0 text-foreground/65"
          }), _jsxs("div", {
            children: [_jsxs("p", {
              children: [_jsx("span", {
                className: "font-medium text-foreground",
                children: "Peak:"
              }), " ", pricingSchedule.peakDays, ", ", pricingSchedule.peakHours, " UTC.", _jsxs(Tooltip, {
                children: [_jsx(TooltipTrigger, {
                  asChild: true,
                  children: _jsx("button", {
                    type: "button",
                    className: "ml-1 inline-flex align-middle text-muted-foreground hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm",
                    "aria-label": "Show schedule in your time zone",
                    children: _jsx(Info, {
                      className: "h-3 w-3"
                    })
                  })
                }), _jsx(TooltipContent, {
                  side: "top",
                  className: "text-xs",
                  children: _jsx(LocalPeakPricingSchedule, {
                    peakPricing: activeMapping.peakPricing
                  })
                })]
              })]
            }), _jsxs("p", {
              children: [_jsx("span", {
                className: "font-medium text-foreground",
                children: "Off-peak:"
              }), " ", pricingSchedule.peakDays, " outside those hours", pricingSchedule.offPeakDays ? ", plus all day ".concat(pricingSchedule.offPeakDays, " UTC") : "", "."]
            })]
          })]
        }), activeMapping.ocrPagePrice !== null && activeMapping.ocrPagePrice !== undefined && Number(activeMapping.ocrPagePrice) > 0 && _jsxs("div", {
          className: "rounded-md bg-background border border-border/30 p-2 flex items-baseline justify-between",
          children: [_jsx("span", {
            className: "text-[10px] uppercase tracking-wider text-muted-foreground",
            children: "OCR"
          }), _jsxs("span", {
            className: "font-mono tabular-nums text-sm",
            children: ["$", (Number(activeMapping.ocrPagePrice) * 1000).toFixed(2), _jsxs("span", {
              className: "text-muted-foreground text-xs",
              children: [" ", "/1K pages"]
            })]
          })]
        }), detailed && (activeMapping.cacheWriteInputPrice || activeMapping.cacheWriteInputPrice1h) && _jsxs("div", {
          className: "grid grid-cols-2 gap-px rounded-md bg-border/30 border border-border/30 overflow-hidden",
          children: [_jsx("div", {
            className: "bg-background p-2",
            children: _jsx(PriceCell, {
              label: "Cache Write 5m",
              price: activeMapping.cacheWriteInputPrice,
              discount: activeMapping.discount,
              unit: "/M tokens",
              formatPrice: formatPrice,
              multiplier: serviceTierMultiplier
            })
          }), _jsx("div", {
            className: "bg-background p-2",
            children: _jsx(PriceCell, {
              label: "Cache Write 1h",
              price: (_x = activeMapping.cacheWriteInputPrice1h) !== null && _x !== void 0 ? _x : activeMapping.cacheWriteInputPrice,
              discount: activeMapping.discount,
              unit: "/M tokens",
              formatPrice: formatPrice,
              multiplier: serviceTierMultiplier
            })
          })]
        }), detailed && activeMapping.outputAudioPrice !== null && activeMapping.outputAudioPrice !== undefined && _jsx("div", {
          className: "rounded-md bg-background border border-border/30 p-2",
          children: _jsx(PriceCell, {
            label: "Audio Output",
            price: activeMapping.outputAudioPrice,
            discount: activeMapping.discount,
            unit: "/M tokens",
            formatPrice: formatPrice,
            multiplier: serviceTierMultiplier
          })
        })]
      }), ((_z = (_y = activeMapping.pricingTiers) === null || _y === void 0 ? void 0 : _y.length) !== null && _z !== void 0 ? _z : 0) > 1 && _jsxs("div", {
        className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
        children: [_jsx("div", {
          className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
          children: "Tiered Pricing"
        }), _jsx("div", {
          className: "space-y-2",
          children: function () {
            var hasCached = activeMapping.pricingTiers.some(function (t) {
              var _a, _b;
              return (_b = (_a = t.peakPricing) === null || _a === void 0 ? void 0 : _a[timeBasedPricingMode].cachedInputPrice) !== null && _b !== void 0 ? _b : t.cachedInputPrice;
            });
            return _jsxs(_Fragment, {
              children: [_jsxs("div", {
                className: "grid ".concat(hasCached ? "grid-cols-[1fr_1fr_1fr_1fr]" : "grid-cols-[1fr_1fr_1fr]", " gap-x-2 text-[10px] text-muted-foreground text-right"),
                children: [_jsx("div", {}), _jsx("div", {
                  children: "IN"
                }), hasCached && _jsx("div", {
                  children: "CACHED"
                }), _jsx("div", {
                  children: "OUT"
                })]
              }), activeMapping.pricingTiers.map(function (pricingTier, index) {
                var _a, _b, _c;
                var tier_0 = __assign(__assign({}, pricingTier), (_a = pricingTier.peakPricing) === null || _a === void 0 ? void 0 : _a[timeBasedPricingMode]);
                var discountNum_2 = discountFraction(activeMapping.discount);
                var prevTokens = (_c = (_b = activeMapping.pricingTiers[index - 1]) === null || _b === void 0 ? void 0 : _b.upToTokens) !== null && _c !== void 0 ? _c : 0;
                var label_2 = tier_0.upToTokens === null ? ">".concat(formatNumber(prevTokens / 1000), "K tokens") : "\u2264".concat(formatNumber(tier_0.upToTokens / 1000), "K tokens");
                return _jsxs("div", {
                  className: "grid ".concat(hasCached ? "grid-cols-[1fr_1fr_1fr_1fr]" : "grid-cols-[1fr_1fr_1fr]", " gap-x-2 items-center text-xs"),
                  children: [_jsx("span", {
                    className: "text-muted-foreground",
                    children: label_2
                  }), _jsx("div", {
                    className: "font-mono tabular-nums flex justify-end",
                    children: formatPrice(tier_0.inputPrice, discountNum_2 > 0 ? String(discountNum_2) : null, "end", serviceTierMultiplier)
                  }), hasCached && _jsx("div", {
                    className: "font-mono tabular-nums flex justify-end",
                    children: tier_0.cachedInputPrice ? formatPrice(tier_0.cachedInputPrice, discountNum_2 > 0 ? String(discountNum_2) : null, "end", serviceTierMultiplier) : "—"
                  }), _jsx("div", {
                    className: "font-mono tabular-nums flex justify-end",
                    children: formatPrice(tier_0.outputPrice, discountNum_2 > 0 ? String(discountNum_2) : null, "end", serviceTierMultiplier)
                  })]
                }, index);
              })]
            });
          }()
        })]
      }), ((_1 = (_0 = activeMapping.imageInputTokensByResolution) !== null && _0 !== void 0 ? _0 : activeMapping.imageOutputTokensByResolution) !== null && _1 !== void 0 ? _1 : activeMapping.imageOutputPrice) && _jsxs("div", {
        className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
        children: [_jsx("div", {
          className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
          children: activeMapping.imageOutputTokensByResolution ? "Image Pricing (est. per image)" : "Image Pricing"
        }), activeMapping.imageInputPrice && activeMapping.imageInputTokensByResolution && function () {
          var imageInputPriceNum = parseFloat(activeMapping.imageInputPrice);
          var named = Object.entries(activeMapping.imageInputTokensByResolution).filter(function (_a) {
            var k = _a[0];
            return k !== "default";
          });
          var defaultTokens = activeMapping.imageInputTokensByResolution["default"];
          var entries = named.length > 0 ? named : defaultTokens !== undefined ? [["any size", defaultTokens]] : [];
          if (entries.length === 0) {
            return null;
          }
          var discountNum_3 = discountFraction(activeMapping.discount);
          return _jsxs("div", {
            className: "mb-1.5",
            children: [_jsx("div", {
              className: "text-[10px] text-muted-foreground mb-0.5",
              children: "Input"
            }), entries.map(function (_a_4) {
              var res = _a_4[0],
                tokensPerImage = _a_4[1];
              var raw = tokensPerImage * imageInputPriceNum * serviceTierMultiplier;
              var discounted_1 = raw * (1 - discountNum_3);
              return _jsxs("div", {
                className: "flex justify-between items-center text-xs py-0.5",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: res
                }), _jsx("span", {
                  className: "font-mono tabular-nums",
                  children: discountNum_3 > 0 ? _jsxs(_Fragment, {
                    children: [_jsxs("span", {
                      className: "line-through text-muted-foreground mr-1",
                      children: ["~$", raw.toFixed(5)]
                    }), _jsxs("span", {
                      className: "text-green-600 font-semibold",
                      children: ["~$", discounted_1.toFixed(5)]
                    })]
                  }) : "~$".concat(raw.toFixed(5))
                })]
              }, res);
            })]
          });
        }(), activeMapping.imageOutputPrice && !activeMapping.imageOutputTokensByResolution && _jsxs("div", {
          children: [_jsx("div", {
            className: "text-[10px] text-muted-foreground mb-0.5",
            children: "Image Output"
          }), _jsxs("div", {
            className: "flex justify-between items-center text-xs py-0.5",
            children: [_jsx("span", {
              className: "text-muted-foreground",
              children: "Tokens"
            }), _jsxs("div", {
              className: "font-mono tabular-nums flex items-center gap-1",
              children: [formatPrice(activeMapping.imageOutputPrice, activeMapping.discount, "end", serviceTierMultiplier), _jsx("span", {
                className: "text-muted-foreground",
                children: "/M tokens"
              })]
            })]
          })]
        }), activeMapping.imageOutputPrice && activeMapping.imageOutputTokensByResolution && function () {
          var imageOutputPriceNum = parseFloat(activeMapping.imageOutputPrice);
          var entries_0 = Object.entries(activeMapping.imageOutputTokensByResolution).filter(function (_a) {
            var k = _a[0];
            return k !== "default";
          });
          if (entries_0.length === 0) {
            return null;
          }
          var discountNum_4 = discountFraction(activeMapping.discount);
          return _jsxs("div", {
            children: [_jsx("div", {
              className: "text-[10px] text-muted-foreground mb-0.5",
              children: "Output"
            }), entries_0.map(function (_a_5) {
              var res_0 = _a_5[0],
                tokensPerImage = _a_5[1];
              var raw_0 = tokensPerImage * imageOutputPriceNum * serviceTierMultiplier;
              var discounted_2 = raw_0 * (1 - discountNum_4);
              return _jsxs("div", {
                className: "flex justify-between items-center text-xs py-0.5",
                children: [_jsx("span", {
                  className: "text-muted-foreground",
                  children: res_0
                }), _jsx("span", {
                  className: "font-mono tabular-nums",
                  children: discountNum_4 > 0 ? _jsxs(_Fragment, {
                    children: [_jsxs("span", {
                      className: "line-through text-muted-foreground mr-1",
                      children: ["~$", raw_0.toFixed(5)]
                    }), _jsxs("span", {
                      className: "text-green-600 font-semibold",
                      children: ["~$", discounted_2.toFixed(5)]
                    })]
                  }) : "~$".concat(raw_0.toFixed(5))
                })]
              }, res_0);
            })]
          });
        }()]
      }), !isImageGen && activeMapping.requestPrice !== null && activeMapping.requestPrice !== undefined && parseFloat(activeMapping.requestPrice) > 0 || activeMapping.webSearchPrice !== null && activeMapping.webSearchPrice !== undefined && parseFloat(activeMapping.webSearchPrice) > 0 ? _jsxs("div", {
        className: "flex flex-wrap items-center justify-center gap-x-3 gap-y-0.5 text-xs text-muted-foreground",
        children: [!isImageGen && activeMapping.requestPrice !== null && activeMapping.requestPrice !== undefined && parseFloat(activeMapping.requestPrice) > 0 && function () {
          var original = parseFloat(activeMapping.requestPrice);
          var discountNum_5 = discountFraction(activeMapping.discount);
          return _jsxs("span", {
            children: ["+", " ", discountNum_5 > 0 ? _jsxs(_Fragment, {
              children: [_jsxs("span", {
                className: "line-through text-muted-foreground mr-1",
                children: ["$", original.toFixed(3)]
              }), _jsxs("span", {
                className: "text-green-600 font-semibold",
                children: ["$", (original * (1 - discountNum_5)).toFixed(3)]
              })]
            }) : "$".concat(original.toFixed(3)), _jsx("span", {
              className: "text-muted-foreground",
              children: " per request"
            })]
          });
        }(), activeMapping.webSearchPrice !== null && activeMapping.webSearchPrice !== undefined && parseFloat(activeMapping.webSearchPrice) > 0 && function () {
          var original_0 = parseFloat(activeMapping.webSearchPrice);
          var discountNum_6 = discountFraction(activeMapping.discount);
          return _jsxs("span", {
            children: ["+", " ", discountNum_6 > 0 ? _jsxs(_Fragment, {
              children: [_jsxs("span", {
                className: "line-through text-muted-foreground mr-1",
                children: ["$", original_0.toFixed(3)]
              }), _jsxs("span", {
                className: "text-green-600 font-semibold",
                children: ["$", (original_0 * (1 - discountNum_6)).toFixed(3)]
              })]
            }) : "$".concat(original_0.toFixed(3)), _jsx("span", {
              className: "text-muted-foreground",
              children: " per search"
            })]
          });
        }()]
      }) : null, isImageGen && hasImageCostEstimate && _jsx("button", {
        type: "button",
        className: "w-full flex items-center justify-center gap-1.5 py-1 text-[11px] text-muted-foreground hover:text-foreground transition-colors",
        onClick: function (e_4) {
          e_4.stopPropagation();
          setShowTokenPricing(function (v) {
            return !v;
          });
        },
        children: showTokenPricing ? _jsxs(_Fragment, {
          children: [_jsx(ChevronUp, {
            className: "h-3 w-3"
          }), "Hide token pricing"]
        }) : _jsxs(_Fragment, {
          children: [_jsx(ChevronDown, {
            className: "h-3 w-3"
          }), "Expand details"]
        })
      }), hasMappingDetails && _jsxs(_Fragment, {
        children: [showMappingDetails && _jsxs("div", {
          id: mappingDetailsId,
          className: "space-y-2.5",
          onClick: function (event) {
            return event.stopPropagation();
          },
          children: [mappingCapabilities.length > 0 && _jsxs("div", {
            className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
            children: [_jsx("div", {
              className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
              children: "Capabilities"
            }), _jsx("div", {
              className: "flex flex-wrap gap-1.5",
              children: mappingCapabilities.map(function (_a_6) {
                var key_0 = _a_6.key,
                  label_3 = _a_6.label;
                var Icon = MAPPING_CAPABILITY_ICONS[key_0];
                return _jsxs(Badge, {
                  variant: "outline",
                  className: "h-6 gap-1.5 border-border/60 bg-background/70 px-2 text-[10px] font-medium text-foreground",
                  children: [_jsx(Icon, {
                    className: "h-3 w-3 text-primary",
                    "aria-hidden": "true"
                  }), label_3]
                }, key_0);
              })
            })]
          }), ((_3 = (_2 = activeMapping.reasoningEfforts) === null || _2 === void 0 ? void 0 : _2.length) !== null && _3 !== void 0 ? _3 : 0) > 0 && _jsxs("div", {
            className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
            children: [_jsx("div", {
              className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
              children: "Reasoning Efforts"
            }), _jsx("div", {
              className: "flex flex-wrap gap-1",
              children: activeMapping.reasoningEfforts.map(function (effort) {
                return _jsx(Badge, {
                  variant: "outline",
                  className: "text-[10px] px-1.5 py-0 h-4 font-mono text-muted-foreground",
                  children: effort
                }, effort);
              })
            })]
          }), ((_5 = (_4 = activeMapping.supportedParameters) === null || _4 === void 0 ? void 0 : _4.length) !== null && _5 !== void 0 ? _5 : 0) > 0 && _jsxs("div", {
            className: "rounded-md bg-muted/40 border border-border/30 p-2.5",
            children: [_jsx("div", {
              className: "text-[10px] uppercase tracking-wider text-muted-foreground mb-2",
              children: "Supported Parameters"
            }), _jsx("div", {
              className: "flex flex-wrap gap-1",
              children: activeMapping.supportedParameters.map(function (param) {
                return _jsx(Badge, {
                  variant: "outline",
                  className: "text-[10px] px-1.5 py-0 h-4 font-mono text-muted-foreground",
                  children: param
                }, param);
              })
            })]
          })]
        }), _jsx("button", {
          type: "button",
          "aria-expanded": showMappingDetails,
          "aria-controls": mappingDetailsId,
          className: "w-full flex items-center justify-center gap-1.5 py-1 text-[11px] text-muted-foreground hover:text-foreground transition-colors",
          onClick: function (e_5) {
            e_5.stopPropagation();
            setShowMappingDetails(function (v_0) {
              return !v_0;
            });
          },
          children: showMappingDetails ? _jsxs(_Fragment, {
            children: [_jsx(ChevronUp, {
              className: "h-3 w-3"
            }), "Hide details"]
          }) : _jsxs(_Fragment, {
            children: [_jsx(ChevronDown, {
              className: "h-3 w-3"
            }), "Show details"]
          })
        })]
      })]
    })]
  });
}